export const SET_STEPS = '[mutations] set steps';
export const GET_STEPS = '[getters] get steps';
export const SET_STEP = '[mutations] set step';
export const GET_STEP = '[getters] get step';